module.exports = __webpack_public_path__ + "img/52.8ffbf1f3.svg";